import { useFetchAttributes } from "@/users/useUserAttributes";

const computeDatadogUserProperties = ({
  active_licenses: activeLicenses,
  classroom_ids: classroomIds,
  classroom_subject_grades: classroomSubjectGrades,
  district_ids: districtIds,
  grade_level: gradeLevel,
  in_district_with_all_advisory_content: inDistrictWithAllAdvisoryContent,
  is_authenticated: isAuthenticated,
  is_demo: isDemo,
  is_staff: isStaff,
  preferred_school_id: preferredSchoolId,
  school_ids: schoolIds,
  state,
  teacher_subjects: teacherSubjects,
  user_id: userId,
  user_roles: roles,
} = {}) => ({
  activeLicenses,
  classroomIds,
  classroomSubjectGrades,
  districtIds,
  gradeLevel,
  inDistrictWithAllAdvisoryContent,
  isAuthenticated,
  isDemo,
  isStaff,
  preferredSchoolId,
  schoolIds,
  state,
  teacherSubjects,
  userId,
  roles,
  id: userId,
});

const useDatadogUserProperties = () => {
  const { userAttributes } = useFetchAttributes();

  return computeDatadogUserProperties(userAttributes);
};

export default useDatadogUserProperties;
